import type { Screen, Severity, UserType } from '@api-client/temporary-messages';

export type MessageId = number | string;

export const Screens: Record<Screen, Screen> = {
    OVERVIEW: 'OVERVIEW',
    CONTACT_AREA: 'CONTACT_AREA',
    STORE: 'STORE',
    NEW_TRANSFER: 'NEW_TRANSFER',
    CURRENT_ACCOUNT_TRANSACTIONS: 'CURRENT_ACCOUNT_TRANSACTIONS',
    CURRENT_ACCOUNT_STATEMENTS: 'CURRENT_ACCOUNT_STATEMENTS',
    CURRENT_ACCOUNT_NEW_SEPA_DD: 'CURRENT_ACCOUNT_NEW_SEPA_DD',
    CARD_CREDIT_TRANSACTIONS: 'CARD_CREDIT_TRANSACTIONS',
    CARD_CREDIT_INVOICES: 'CARD_CREDIT_INVOICES',
    SAVING_ACCOUNT_ALL: 'SAVING_ACCOUNT_ALL',
    LOAN_ACCOUNT_ALL: 'LOAN_ACCOUNT_ALL',
    PAYMENT_ORDERS: 'PAYMENT_ORDERS',
    SECURITIES_ACCOUNT_OVERVIEW: 'SECURITIES_ACCOUNT_OVERVIEW',
    SECURITIES_ORDER_BUY: 'SECURITIES_ORDER_BUY',
    SECURITIES_ORDER_SELL: 'SECURITIES_ORDER_SELL',
    SECURITIES_SEARCH: 'SECURITIES_SEARCH',
    SECURITIES_ACCOUNT_STATEMENTS: 'SECURITIES_ACCOUNT_STATEMENTS',
    SECURITIES_ACCOUNT_ORDERS: 'SECURITIES_ACCOUNT_ORDERS',
    DATACARRIER: 'DATACARRIER',
    FINANCE_MANAGER: 'FINANCE_MANAGER',
    PROFILE: 'PROFILE',
    MOBILE_PAYMENTS: 'MOBILE_PAYMENTS',
    INVEST_TAB: 'INVEST_TAB',
    CARDS_OVERVIEW: 'CARDS_OVERVIEW',
    APPROVALS: 'APPROVALS',
    DOCUMENTS_AND_REQUESTS: 'DOCUMENTS_AND_REQUESTS',
    NEW_STANDING_ORDER: 'NEW_STANDING_ORDER',
    NEW_SINGLE_DIRECT_DEBIT: 'NEW_SINGLE_DIRECT_DEBIT',
    NEW_SEPA_DIRECT_DEBIT: 'NEW_SEPA_DIRECT_DEBIT',
    STANDING_ORDERS: 'STANDING_ORDERS',
    DIRECT_DEBIT_APPROVALS: 'DIRECT_DEBIT_APPROVALS',
    ACCOUNTS_OVERVIEW: 'ACCOUNTS_OVERVIEW',
    FINANCING_OVERVIEW: 'FINANCING_OVERVIEW',
    DATA_IMPORT: 'DATA_IMPORT',
    ADDRESSBOOK_CONTACTS: 'ADDRESSBOOK_CONTACTS',
    ADDRESSBOOK_TEMPLATES: 'ADDRESSBOOK_TEMPLATES',
    ADDRESSBOOK_MANDATES: 'ADDRESSBOOK_MANDATES',
    USER_MANAGEMENT: 'USER_MANAGEMENT',
    FX_PRODUCTS: 'FX_PRODUCTS',
    FX_PRODUCTS_NEW_TRADE: 'FX_PRODUCTS_NEW_TRADE',
    MULTIBANKING: 'MULTIBANKING',
    EXPORT_STATEMENTS: 'EXPORT_STATEMENTS',
    NEW_DIRECT_DEBIT_APPROVAL: 'NEW_DIRECT_DEBIT_APPROVAL',
    NEW_BULK_TRANSFER: 'NEW_BULK_TRANSFER',
    FINANCIAL_HEALTH: 'FINANCIAL_HEALTH',
} as const;

export const UserTypes: Record<string, UserType> = {
    JUNIOR: 'JUNIOR',
    REGULAR: 'REGULAR',
};

export const Severities: Record<string, Severity> = {
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
};

type DefaultRouteConfig = {
    path: string;
    end?: boolean;
};

export type ScreenToPathsMap = Record<Screen, DefaultRouteConfig[]>;
